<template>
  <img v-if="imageUrl" :src="imageUrl" :alt="alt" />
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref, watch } from 'vue'
import { http } from '@/core/http/client'

const props = withDefaults(defineProps<{ src?: string; alt?: string }>(), {
  src: '',
  alt: ''
})

const imageUrl = ref('')
let objectUrl = ''
let loadSequence = 0

watch(
  () => props.src,
  (src) => void load(src),
  { immediate: true }
)

onBeforeUnmount(releaseObjectUrl)

async function load(src?: string) {
  const sequence = ++loadSequence
  releaseObjectUrl()
  const path = src?.trim()
  if (!path) return
  if (/^(?:data:|blob:)/i.test(path)) {
    imageUrl.value = path
    return
  }

  try {
    const result = await http.download(path, undefined, { skipLoading: true })
    if (sequence !== loadSequence) return
    objectUrl = URL.createObjectURL(result.blob)
    imageUrl.value = objectUrl
  } catch {
    if (sequence === loadSequence) imageUrl.value = ''
  }
}

function releaseObjectUrl() {
  imageUrl.value = ''
  if (!objectUrl) return
  URL.revokeObjectURL(objectUrl)
  objectUrl = ''
}
</script>
